import instance, { ADMIN_PREFIX } from 'services/api';

// Wire shape for GET /api/v2/admin/activity-log rows. Mirrors the
// legacy GQL fragment 1:1 (snake_case keys, nested user with role).
export interface ActivityLogRow {
  id: number;
  ip: string | null;
  activity: string | null;
  date: string | null;
  device: string | null;
  user: {
    id: number;
    first_name: string;
    last_name: string;
    role: { name: string };
  } | null;
}

export interface ActivityLogListResponse {
  results: ActivityLogRow[];
  total: number;
}

export interface FetchActivityLogParams {
  page: number;
  limit: number;
}

export const fetchActivityLogList = (params: FetchActivityLogParams) =>
  instance.get<ActivityLogListResponse>(`${ADMIN_PREFIX}/activity-log`, {
    params
  });
